import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

import { VpHookFormColorInput, VpHookFormInput } from '../..';
import { useFetchPluginById } from '../../../hooks';

export const VpPluginBorderInputs = ({ disabled }) => {
  const { data } = useFetchPluginById();
  const borderData = data?.styles.border;
  const [borderWidth, borderColor] =
    borderData && borderData !== 'none' ? borderData.split(' solid ') : ['1px', 'rgb(0 0 0 / 1)'];

  return (
    <Stack direction="row" alignItems="end" spacing={1}>
      <VpHookFormInput
        disableHelperText
        isNumber
        defaultValue={data?.styles?.borderRadius}
        maxLength={2}
        required
        name="borderRadius"
        startAdornment="Radius"
        disabled={disabled}
        fallbackDefaultValue="8"
        includeDisplayInput
      />
      <VpHookFormInput
        isNumber
        defaultValue={borderWidth}
        maxLength={2}
        required
        name="borderWidth"
        startAdornment="Stroke"
        disableHelperText
        disabled={disabled}
        fallbackDefaultValue="1"
        includeDisplayInput
      />
      <VpHookFormColorInput
        isRgba
        required
        name="borderColor"
        disableHelperText
        defaultValue={borderColor}
        disabled={disabled}
      />
    </Stack>
  );
};

VpPluginBorderInputs.propTypes = {
  disabled: PropTypes.bool
};

export default VpPluginBorderInputs;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/plugin-details/VpPluginBorderInputs.jsx